import { ContainerDefault } from '../Layouts';
import { Loader } from '../Loader';

export const LoaderPage = () => {
    return (
        <ContainerDefault classNames="grid place-content-center">
            <Loader />
        </ContainerDefault>
    );
};
